import type { ReactNode } from 'react';
import { Search } from 'lucide-react';

/**
 * The "Find item" search box pinned to the top of every document listing
 * (Requirements, Components, Design, and the Build console's Standards/Validate
 * once they adopt DocListSection). One control, one look — surfaces differ only
 * in what they list, so the way you search them is shared. Extra, surface-
 * specific controls (e.g. the org select) render inline after the box via
 * `children`, on the same row.
 */
export function FindItemBar({
  value,
  onChange,
  placeholder = 'Find item…',
  children,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <div className="relative flex-1 min-w-[12rem]">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400 pointer-events-none" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          aria-label="Find item"
          onChange={(e) => onChange(e.target.value)}
          className="w-full pl-8 pr-3 py-1.5 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm text-slate-900 dark:text-slate-100"
        />
      </div>
      {children}
    </div>
  );
}
